import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=36fe2b4e"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=36fe2b4e&prod&lang=css"
import style1 from "./Catalogue.vue?vue&type=style&index=1&id=36fe2b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports